import { render, staticRenderFns } from "./AutomaticBilling.vue?vue&type=template&id=9434107a&"
import script from "./AutomaticBilling.vue?vue&type=script&lang=js&"
export * from "./AutomaticBilling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VApp,VSwitch})
